export default {
  archivesDisinfectDetail: {
    component: () =>
      import(
        "@/mods/warehouse/archivesDisinfect/detailView/ArchivesDisinfectDetail"
      ),
  },
};
